import { render, staticRenderFns } from "./BoardListPrimeLayout.vue?vue&type=template&id=6f753cc7&scoped=true&"
import script from "./BoardListPrimeLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListPrimeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f753cc7",
  null
  
)

export default component.exports